import * as d3 from 'd3';
import React from 'react';

import notifications from 'notifications';
import * as keyboard from 'util/Keyboard';
import throttle from 'util/throttle';

function checkZoom(): void {
  if (window.getComputedStyle == null) {
    return;
  }
  const text = d3.select('#verify-zoom').select('svg').select('text');
  if (text == null || text.node() == null) {
    return;
  }
  const expected = text.attr('font-size');
  const actual = window.getComputedStyle(text.node() as Element).getPropertyValue('font-size');
  if (expected !== actual) {
    const msg = (
      <>
        Your browser's zoom level is not supported. Please reset to the default zoom level by hitting{' '}
        <strong>${keyboard.ctrl}-0</strong> for the optimal Benchling experience.
      </>
    );
    notifications.info(msg, {
      closeable: false,
      duration: 0,
      id: 'bad-zoom',
    });
  } else {
    notifications.close('bad-zoom');
  }
}

export function registerBrowserZoomCheck(): void {
  checkZoom();
  $(window).on('resize.bad-zoom-check', throttle(checkZoom, 1000));
}

export function unregisterBrowserZoomCheck(): void {
  $(window).off('.bad-zoom-check');
  notifications.close('bad-zoom');
}
